import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, PagingResponseModel} from '../../shared';
import {InquiryContainerModel} from '../../../../../../models/aggregates/erp/inquiry';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import {InquiriesQueryCriteriaClass, InquiriesCriteriaModelQuery} from '../../../criteria/inquiries-criteria.model';


@Injectable({
  providedIn: 'root'
})
export class InquiryService extends BaseApiTemplateService<InquiryContainerModel> {
  // readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'inquiries';
    this.httpClient = http;
  }
  getInquiryByCriteria(visa: ApiVisa, criteria?: InquiriesQueryCriteriaClass):
    Observable<PagingResponseModel<InquiryContainerModel>> {
    const buildEntityCriteriaCriteria = new InquiriesCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<InquiryContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }
}


